import React, {useEffect, useRef, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useGlobalNotificationMessage} from "../../context/message";
import PageTitle from "../../components/page-title";
import {useUserService} from "../../services/user-service";
import DataTableActions from "../../components/datatable/data-table-actions";
import DataTableBase from "../../components/datatable/data-table-base";
import AddEditUserModal from "./add-edit-user-modal";
import {useNavigate} from "react-router-dom";
import {AppRoutes, ContactTypes} from "../../utils/constants";
import {forgotPassword} from "../../services/auth-service";


export default function UsersList () {
  let userService = useUserService();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const addEditModal = useRef();
  const navigate = useNavigate();

  useEffect(()=>{
    userService.getList()
      .then((rows)=>{
        setRows(rows);
        setLoaded(true);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta.");
      })
  }, []);

  const onAddEditAction = (row=null, e=null)=>{
    addEditModal.current.openModal(row);
  };

  const onAddEditCallbackAction = (item=null)=>{
    setRows(HelperService.addOrReplaceItemInList(rows,item));
  };

  const onDelAction = (item, e=null)=>{
    if (true===confirm('Naozaj odstrániť záznam?')){
      userService.delModel(item.id)
        .then(()=>{
          setRows(HelperService.removeItemFromList(rows,item));
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  const onResetPasswordAction = (item, e=null)=>{
    if (true===confirm('Odoslať pokyny na zmenu hesla na email?')){
      forgotPassword({email: item.email})
        .then(()=>{
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  const onToggleActiveAccountAction = (item, e=null)=>{
    if (true===confirm('Prepnúť aktívny stav účtu? Používateľ sa nebude vedieť prihlásiť.')){
      userService.toggleActiveAccount(item.id)
        .then((newItem)=>{
          console.log(newItem);
          setRows(HelperService.addOrReplaceItemInList(rows,newItem));
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  const columns = [{
    name: 'Meno',
    selector: row => row.name,
    sortable: true,
  },{
    name: 'Rola',
    selector: row => row.global_roles[0]?.title,
    sortable: true,
  },{
    name: 'Email',
    selector: row => !row.contacts ? '' : row.contacts.filter(item=>item.type===ContactTypes.email.val).map(item=>item.contact).join(', '),
    sortable: true,
  },{
    name: 'Tel',
    selector: row => !row.contacts ? '' : row.contacts.filter(item=>item.type===ContactTypes.tel.val).map(item=>item.contact).join(', '),
    sortable: true,
  },{
    name: 'Stav',
    center: true,
    selector: row => row.is_login_allowed,
    format: row => row.is_login_allowed
      ? <span title="Aktívny účet" className="mdi mdi-checkbox-marked-circle-outline text-success"></span>
      : <span title="Neaktívny účet" className="mdi mdi-alpha-x-circle-outline text-danger"></span>,
    filterSelector: row => { return row.is_login_allowed ? 'Aktívny' : 'Neaktívny'},
    sortable: true,
  },{
    cell: row => <DataTableActions row={row} actions={[
      {title: 'Upraviť', icon: <span className="mdi mdi-book-edit-outline"></span>, action: onAddEditAction, className: 'hover-text-primary'},
      {title: 'Obnoviť heslo', icon: <span className="mdi mdi-key"></span>, action: onResetPasswordAction, className: 'hover-text-primary'},
      {title: 'Prepnúť stav účtu', icon: <span className="mdi mdi-shield-account"></span>, action: onToggleActiveAccountAction, className: 'hover-text-danger'},
      {title: 'Zmazať', icon: <span className="mdi mdi-trash-can-outline"></span>, action: onDelAction, className: 'hover-text-danger'},
    ]} />,
    right: true,
    allowOverflow: true,
    button: false,
  }];

  return (
    <>
      <AddEditUserModal ref={addEditModal} onSuccess={onAddEditCallbackAction} />

      <Section animation={HelperService.getRandomAnimation()}>
        <div className="container mt-4">

          <PageTitle>Používatelia</PageTitle>

          <button className="btn btn-primary mb-2" onClick={(e)=>onAddEditAction(null, e)}><span className="mdi mdi-plus"></span> Pridať</button>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">

                 <DataTableBase
                    progressPending={!loaded}
                    columns={columns}
                    data={rows}
                    onRowClicked={(row)=>navigate(`${AppRoutes.users.path}/${row.id}`)}
                    dense
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}

UsersList.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

UsersList.getSEO = function getSEO() {
  return {
    title: "Používatelia",
  }
}
